import {
  TrackContactCreationFilters,
  GetTrackContactCreationResponse,
} from '../../types/trackContactCreation/trackContactCreation.types';

// Action type constants
export const GET_TRACK_CONTACT_CREATION_REQUEST =
  'GET_TRACK_CONTACT_CREATION_REQUEST';
export const GET_TRACK_CONTACT_CREATION_SUCCESS =
  'GET_TRACK_CONTACT_CREATION_SUCCESS';
export const GET_TRACK_CONTACT_CREATION_FAILURE =
  'GET_TRACK_CONTACT_CREATION_FAILURE';
export const CLEAR_TRACK_CONTACT_CREATION_STATE =
  'CLEAR_TRACK_CONTACT_CREATION_STATE';

// Action interfaces
export interface GetTrackContactCreationRequestAction {
  type: typeof GET_TRACK_CONTACT_CREATION_REQUEST;
  payload: TrackContactCreationFilters;
  [key: string]: any;
}

export interface GetTrackContactCreationSuccessAction {
  type: typeof GET_TRACK_CONTACT_CREATION_SUCCESS;
  payload: GetTrackContactCreationResponse;
  [key: string]: any;
}

export interface GetTrackContactCreationFailureAction {
  type: typeof GET_TRACK_CONTACT_CREATION_FAILURE;
  payload: string;
  [key: string]: any;
}

export interface ClearTrackContactCreationStateAction {
  type: typeof CLEAR_TRACK_CONTACT_CREATION_STATE;
  [key: string]: any;
}

// Union type for all track contact creation actions
export type TrackContactCreationActionTypes =
  | GetTrackContactCreationRequestAction
  | GetTrackContactCreationSuccessAction
  | GetTrackContactCreationFailureAction
  | ClearTrackContactCreationStateAction;
